module.exports = __webpack_public_path__ + "static/media/sbf-website-view-2.98bc7714.png";